export class FooterConfig {
    // TODO - proper test coverage
    /* istanbul ignore next */
    constructor(public horizontalSeparator: boolean = false) { }
}
